/**
 * staffRosterRows.ts
 * Shared derivation of the plan's distinct employee rows = the union of people
 * assigned to a task (role from the assignment) and people on the source roster
 * (role unknown until their presence materializes). Sorted by displayName.
 *
 * Extracted so BOTH the legacy Phase2CapacityTable and the "Staff this job" v2
 * model (useStaffJobModel) compute the same set (no duplication — CODING-STANDARDS).
 */

import type { RosterWeek } from '../../../../services/scheduleRoster';
import type { TaskAssignee } from '../../../../services/scheduleTasks';
import type { EmployeeRow } from './phase2CapacityShared';

export type { EmployeeRow } from './phase2CapacityShared';

export function mergeEmployeeRows(
  assignmentMap: Record<string, TaskAssignee[]>,
  rosterWeeks: RosterWeek[],
): EmployeeRow[] {
  const seen = new Map<string, EmployeeRow>();
  for (const rows of Object.values(assignmentMap)) {
    for (const r of rows) {
      const lk = r.UserKey.toLowerCase();
      if (!seen.has(lk)) {
        seen.set(lk, { userKey: r.UserKey, displayName: r.displayName, role: r.tier ?? null, email: r.email ?? null });
      }
    }
  }
  for (const w of rosterWeeks) {
    for (const e of w.entries) {
      const lk = e.userKey.toLowerCase();
      if (!seen.has(lk)) {
        seen.set(lk, { userKey: e.userKey, displayName: e.displayName, role: null, email: e.email ?? null });
      }
    }
  }
  return Array.from(seen.values()).sort((a, b) => a.displayName.localeCompare(b.displayName));
}
